import {
  Row,
  Col,
  Card,
  Tooltip,
  Radio,
  Typography,
  Input,
  Modal,
  Button,
  message,
} from "antd";

import {
  DeleteOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import axios from "axios";

import React, { useEffect, useState } from "react";
import AddProductForm from "../components/AddProductForm";
import UpdateProductForm from "../components/UpdateProductForm";
import { BASE_URL } from "../constants/Constants";

const { Meta } = Card;
const { Title } = Typography;

const ProductOperation = () => {
  const userId = localStorage.getItem("userId");
  const [product, setProduct] = useState([]);
  const [isAddProductModalVisible, setIsAddProductModalVisible] =
    useState(false);
  const [isUpdateProductModalVisible, setIsUpdateProductModalVisible] =
    useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isShowingHiddenProducts, setIsShowingHiddenProducts] = useState(false);
  const [updatedBoolean, setUpdatedBoolean] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");


  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const showAddProductModal = () => {
    setIsAddProductModalVisible(true);
  };

  const hideAddProductModal = () => {
    setIsAddProductModalVisible(false);
  };

  const showUpdateProductModal = (product) => {
    setSelectedProduct(product);
    setIsUpdateProductModalVisible(true);
  };

  const hideUpdateProductModal = () => {
    setSelectedProduct(null);
    setIsUpdateProductModalVisible(false);
  };


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsShowingHiddenProducts(false);
      const response = await axios.get(`${BASE_URL}/api/customProducts/all`);

      const items = response?.data;
      // Sort products by creation date in descending order
      const sortedItems = items.sort(
        (a, b) =>
          new Date(b.productUpdatedDateAndTime) -
          new Date(a.productUpdatedDateAndTime)
      );

      setProduct(sortedItems);

      console.log(sortedItems);
    } catch (error) {
      console.log(error);
    }
  };

  const filteredProducts = product.filter(
    (p) =>
      p.productName.toLowerCase().includes(searchTerm) ||
      p.productId.toLowerCase().includes(searchTerm)
  );

  const handleProductHide = async (product) => {
    try {
      const productId = product.productId;
      console.log(productId);
      const currentDateTime = new Date().toISOString().slice(0, -1);

      // Send the body as JSON with the "isHidden" field
      const response = await axios.put(
        `${BASE_URL}/api/customProducts/${productId}/visibility`,
        { isHidden: true, updatedDateAndTime: currentDateTime } // Send the boolean as an object
      );

      const updatedProducts = await axios.get(
        `${BASE_URL}/api/customProducts/all`
      );
      setProduct(updatedProducts.data);
      message.success("Product Hidden");
      console.log("Product Updated Successfully");
    } catch (error) {
      console.log("Error: ", error.message);
    }
  };

  const fetchHiddenProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/customProducts/hidden`);
      const hiddenItems = response?.data;

      setProduct(hiddenItems);
      setIsShowingHiddenProducts(true);
      console.log(hiddenItems);
    } catch (error) {
      console.log("Error: ", error.message);
    }
  };

  const handleProductUnhide = async (product) => {
    try {
      const productId = product.productId;
      console.log(productId);

      const currentDateTime = new Date().toISOString().slice(0, -1);

      // Send the body as JSON with the "isHidden" field
      const response = await axios.put(
        `${BASE_URL}/api/customProducts/${productId}/visibility`,
        { isHidden: false, updatedDateAndTime: currentDateTime } // Send the boolean as an object
      );

      const updatedProducts = await axios.get(
        `${BASE_URL}/api/customProducts/all`
      );

      setProduct(updatedProducts.data);
      message.success("Product Unhidden");
      window.location.reload();
      console.log("Product Updated Successfully");
    } catch (error) {
      console.log("Error: ", error.message);
    }
  };

  return userId ? (
    <React.Fragment>
      <div>
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Product Data"
              extra={
                <React.Fragment>
                  {" "}
                  <Input.Search
                    placeholder="Search products by name and Id"
                    onChange={handleSearch}
                    style={{ width: 500, marginRight: "20px" }}
                  />
                  {isShowingHiddenProducts ? (
                    <Radio.Group
                      defaultValue="a"
                      style={{ marginRight: "20px" }}
                    >
                      <Radio.Button
                        value="a"
                        onClick={fetchData}
                        type="primary"
                      >
                        All Products
                      </Radio.Button>
                    </Radio.Group>
                  ) : (
                    <Radio.Group
                      defaultValue="a"
                      style={{ marginRight: "20px" }}
                    >
                      <Radio.Button
                        value="a"
                        onClick={fetchHiddenProducts}
                        type="primary"
                      >
                        Show Hidden Products
                      </Radio.Button>
                    </Radio.Group>
                  )}
                  <Radio.Group defaultValue="a">
                    <Radio.Button
                      value="a"
                      onClick={showAddProductModal}
                      type="primary"
                    >
                      Add Product
                    </Radio.Button>
                    <AddProductForm
                      product={product}
                      visible={isAddProductModalVisible}
                      onClose={hideAddProductModal}
                    />
                  </Radio.Group>
                </React.Fragment>
              }
            ></Card>
          </Col>
        </Row>
      </div>

      <Row gutter={[24, 24]}>
        {filteredProducts?.map((product) => {
          const firstPhotoUrl = product.prodImg1 ? product.prodImg1 : "";
          return (
            <Col key={product?.productId} xs={24} sm={12} md={8} lg={6}>
              <Card
                style={{ width: "100%", overflow: "hidden" }}
                cover={
                  <div className="h-[180px] overflow-hidden bg-cover justify-center items-center flex w-full">
                    <img
                      alt="productThumbnailImage"
                      src={firstPhotoUrl}
                      width={"100%"}
                      height={"100%"}
                    />
                  </div>
                }
                actions={
                  isShowingHiddenProducts
                    ? [
                        <Button
                          key="unhide"
                          onClick={() => handleProductUnhide(product)}
                        >
                          UNHIDE
                        </Button>,
                      ]
                    : [
                        <Tooltip title="Edit">
                          <EditOutlined
                            style={{ color: "green" }}
                            key="edit"
                            onClick={() => showUpdateProductModal(product)}
                          />
                        </Tooltip>,

                        <Tooltip title="Hide">
                          <EyeInvisibleOutlined
                            style={{ color: "darkBlue" }}
                            key="hide"
                            onClick={() => handleProductHide(product)}
                          />
                        </Tooltip>,
                      ]
                }
              >
                <Meta
                  title={product?.productName}
                  description={product?.description}
                />
              </Card>
            </Col>
          );
        })}
      </Row>

      {/* UpdateProductForm */}
      {selectedProduct && (
        <>
          <UpdateProductForm
            visible={isUpdateProductModalVisible}
            onClose={hideUpdateProductModal}
            product={selectedProduct}
            onUpdate={(updatedProduct) => {
              setProduct((prevProducts) =>
                prevProducts.map((p) =>
                  p.productId === updatedProduct.productId ? updatedProduct : p
                )
              );
              hideUpdateProductModal();
            }}
            updatedBoolean={updatedBoolean}
            setUpdatedBoolean={setUpdatedBoolean}

          />
        </>
      )}
    </React.Fragment>
  ) : (
    <span
      style={{
        fontSize: "20px",
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      Sign in to see Products
    </span>
  );
};

export default ProductOperation;
